module.exports = __webpack_public_path__ + "static/media/cu_logo.5f298d57.png";